const getPageNumber = (offset: number, limit: number): number => {
    if (
        typeof offset === "undefined" ||
        typeof limit === "undefined" ||
        limit < 1
    ) {
        return 0;
    }
    const pageNumber = Math.ceil((offset - 1) / limit + 1);
    return pageNumber;
};

export default getPageNumber;
